export default __webpack_public_path__ + "static/media/ovalCopy14.59e55cda.svg";